import PropTypes from "prop-types";

export const position = PropTypes.exact({
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired
});
